const fi = Object.freeze({
  hello: 'Hei',
  home: 'Kotisivu',
  receiptPosting: 'Vastaanotto',
  products: 'Tuotteet',
  addProduct: 'Lisää tuote',
  addNewProduct: 'Lisää uusi tuote',
  auctions: 'Huutokaupat',
  welcome: 'Tervetuloa',
  reception: 'Vastaanotto',
  addReception: 'Aloita vastaanotto',
  addClient: 'Lisää asiakas',
  seller: 'Asiakas',
  dateOfDropOff: 'Jätetty pvm',
  estimatedWorth: 'Arvioitu arvo',
  associatedWith: 'Liittyy',
  changelog: 'Muutosloki',
  save: 'Tallenna',
  goBack: 'Takaisin',
  UseOldProduct: 'Käytä olemassaolevan tuotteen tiedot',
  comment: 'Sisäinen kommentti',
  description: 'Kuvaus',
  english: 'Englanti',
  finnish: 'Suomi',
  swedish: 'Ruotsi',
  finland: 'Suomi',
  europe: 'Eurooppa',
  otherCountries: 'Muut maat',
  addToAuction: 'Lisää huutokauppaan',
  technicalInformation: 'Tarkemmat tiedot',
  material: 'Materiaali',
  fitnessRating: 'Kuntoluokka',
  reference: 'Referenssi',
  year: 'Vuosi',
  country: 'Maa',
  nominalValue: 'Nimellisarvo',
  weight: 'Paino',
  size: 'Koko',
  nextSteps: 'Jatkotoimenpiteet',
  nextStep: 'Jatkotoimenpide',
  andThen: 'Sijoita kohde',
  publish: 'Valmis',
  saveDraft: 'Tallenna keskeneräisenä',
  editSelectedReceptions: 'Muokkaa valittuja vastaanottoja',
  editReception: 'Muokkaa vastaanottoa',
  editCase: 'Muokkaa toimeksiantoa',
  newCase: 'Uusi toimeksianto',
  upload: 'Lisää',
  uploading: 'Lisätään',
  personnelAssigned: 'Vastuuhenkilö(t)',
  status: 'Tila',
  productStatus: 'Tuotteen tila',
  featuredImage: 'Pääkuva',
  required: 'Pakollinen tieto',
  adminNote: 'Kommentti',
  name: 'Nimi',
  condition: 'Kunto',
  conditionDescription: 'Kunnon tarkempi kuvaus',
  quantity: 'Määrä',
  ruler: 'Hallitsija',
  olympia: 'Olympia',
  designer: 'Suunnittelija',
  manufacturer: 'Valmistaja',
  taxableStatus: 'Verotusluokka',
  webShopPrice: 'Hinta verkkokaupassa',
  purchasedPrice: 'Ostohinta',
  AuctionMinimumPrice: 'Huutokaupan lähtöhinta',
  estimatedPrice: 'Arvioitu hinta',
  productCategory: 'Tuotekategoria',
  editNewProduct: 'Muokkaa tuotetta',
  editProducts: 'Muokkaa tuotteita',
  editSelectedProducts: 'Muokkaa valittuja tuotteita',
  filter: 'Suodata',
  inAuction: 'Huutokaupassa',
  inWebshop: 'Verkkokaupassa',
  notSold: 'Ei myyty',
  bulkEdit: 'Muokkaa useaa kohdetta',
  image: 'Kuva',
  date: 'Pvm',
  edit: 'Muokkaa',
  assignToWoocommerce: 'Verkkokauppaan',
  AssignToAuction: 'Huutokauppaan',
  PutIntoStorage: 'Varastoon',
  holmastoWillBuyIt: 'Holmasto ostaa',
  holmastoWillSellIt: 'Holmasto myy asiakkaan puolesta (huutokauppa)',
  returnToSeller: 'Palautetaan myyjälle',
  auction: 'Huutokauppa',
  addAuction: 'Luo uusi huutokauppa',
  auctionId: 'Huutokaupan numero',
  startDate: 'Alkupäivä',
  estimatedValue: 'Arvioitu arvo',
  categories: 'Kategoriat',
  uncategorizedProduct: 'Huutokauppakohteet ilman kategoriaa',
  login: 'Kirjaudu sisään',
  forgotPassword: 'Unohditko salasanan?',
  resetPassword: 'Resetoi salasana',
  notValidEmail: 'Tämä sähköpostiosoite on jo käytössä',
  backToLogin: 'Takaisin sisäänkirjaukseen',
  createdAt: 'Luotu',
  email: 'Sähköposti',
  users: 'Työntekijät',
  addUser: 'Lisää',
  firstName: 'Etunimi',
  lastName: 'Sukunimi',
  postalCode: 'Postinumero',
  admin: 'Admin',
  shippingContainer: 'Pakettikoko',
  small: 'Pieni (fi)',
  medium: 'Medium (fi)',
  large: 'Suuri (fi)',
  requiresSpecialHandling: 'Vaatii erikoiskäsittelyn',
  owner: 'Asiakas',
  proposedPrice: 'Ehdotettu sisäänostohinta',
  proposalText: 'Ehdotuksen vapaa teksti',
  city: 'Kaupunki',
  state: 'Osavaltio',
  additionalAddress: 'Lisäosoite',
  areYouSure: 'Oletko varma?',
  cancel: 'Keskeytä',
  delete: 'Poista',
  thisActionCanNotBeUndone: 'Tätä toimenpidettä ei voi peruuttaa',
  warehouseId: 'Varastopaikka',
  lengthShouldBe1: 'Pituus tulee olla 1 ',
  onlyCapitalAlphabeticChars: 'Vain isoja kirjaimia',
  active: 'Aktiivinen',
  inactive: 'Passiivinen',
  sentForApproval: 'Lähetä asiakkaalle hyväksyttäväksi',
  draft: 'Luonnos',
  rejected: 'Hylätty',
  accepted: 'Hyväksytty',
  pending: 'Odottaa',
  holmasto: 'Holmasto',
  customer: 'Asiakas',
  itemStatus: 'Kohteiden status',
  noImage: 'KUVA PUUTTUU',
  noInformation: 'TIETO PUUTTUU',
  createCategory: 'Luo kategoria',
  editCategory: 'Muokkaa kategoriaa',
  label: 'Tarra',
  categoryImage: 'Kategoriakuva',
  chooseImage: 'Valitse kuva',
  choose: 'Calitse',
  category: 'Kategoria',
  productsYoureEditing: 'Tuotteet jota editoit',
  changeFieldsToUpdate: 'Muuta kentät päivittääksesi',
  updateAll: 'Päivitä kaikki',
  auctionCategory: 'Huutokauppakategoriat',
  productCategories: 'Tuotekategoriat',
  sku: 'SKU',
  maxLengthIsThree: 'Max 3 merkkiä',
  editAuction: 'Muokkaa huutokauppaa',
  generatePdf: 'Tulosta tarra',
  markAsComplete: 'Merkkaa valmiiksi',
  experts: 'Asiantuntijat',
  completed: 'Valmis',
  incomplete: 'Kesken',
  canBeSentByAssignedPersona: 'Ehdotuksen voi lähettää vain vastuuhenkilö',
  sendProposal: 'Lähetä ehdotus asiakkaalle',
  publishForPrebid: 'Julkaise ennakkohuutoluettelo',
  editUser: 'Muokkaa työntekijä',
  from: 'Lähettäjä',
  to: 'Vastaanottaja',
  images: 'Kuvat',
  superAdmin: 'Super Admin',
  role: 'Rooli',
  client: 'Asiakas',
  disable: 'Poista luettelosta',
  enable: 'Ota käyttöön',
  parent: 'Kuuluu tämän alle',
  newPasswordWasSentToUser: 'Uusi salasana on lähetetty työntekijälle',
  changePassword: 'Muuta salasanasi',
  profile: 'Profiili',
  logOut: 'Kirjaudu ulos',
  password: 'Salasana',
  confirmPassword: 'Vahvista salasana',
  passwordsDoesntMatch: 'Salasana ei täsmää',
  passwordWasUpdated: 'Salasanasi on päivitetty',
  profileWasUpdated: 'Profiili on päivitetty',
  passwordShouldBemoreThen6Chars: 'Salasanan tulee olla pitempi kuin 6 merkkiä',
  wrongPassword: 'Väärä salasana',
  currentPassword: 'Nykyinen salasana',
  mightBuyLabel: 'Sisältää tuotteita joita Holmasto saattaa ostaa',
  soldOnBehalfLabel: 'Sisältää huutokauppaan meneviä tuotteita',
  internalNote: 'Sisäinen kommentti',
  startDatePreBid: 'Ennakkohuuto avataan',
  createTag: 'Luo Tägi',
  endDatePreBid: 'Ennakkohuuto sulkeutuu',
  auctionIdShouldBeUnique: 'Huutokauppanumero on jo käytössä',
  more: 'Enemmän',
  less: 'Vähemmän',
  itemNumber: 'Kohdenumero',
  dateTime: 'Pvm ja aika',
  user: 'Käyttäjä',
  userId: 'Käyttäjätunnus',
  bid: 'Tarjoukset',
  bids: 'Tarjous',
  amount: 'Määrä',
  addBid: 'Lisää tarjous',
  minimumAmountIs: 'Pienin tarjous vähintään',
  increase: 'KOROTA',
  timeToMakeAnOffer: 'Aikaa tehdä tarjous',
  nSeconds: '{{ n }} sek',
  timerLength: 'Tarjousajan pituus',
  startAgain: 'MEKLAA KOHDE UUDESTAAN',
  pause: 'PYSÄYTÄ',
  resume: 'JATKA',
  next: 'SEURAAVA',
  liveAuctionHasEndedAt: 'Live-huutokauppa on sulkeutunut {{ date }}',
  paletteNumber: 'Salinumero',
  fieldShouldBeUnique: 'Tämänniminen käyttäjä on jo olemassa',
  liveAuction: 'Live huutokauppa',
  shouldBeInteger: 'Tulee olla kokonaisluku',
  attachUserOnBid: 'Kiinnitä asiakas huutoon',
  complete: 'Valmis',
  bidding: 'Huutaminen',
  bidder: 'Huutaja',
  nextItem: 'Seuraava kohde',
  itemNumberNofT: 'Kohdenumero {{ n }} / {{ t }}',
  raise: 'KOROTUS',
  minimumRise: 'Korotus',
  minimumRiseN: 'Korotus (minimi {{ n }} €)',
  closeCurrentItem: 'VASAROI KOHDE',
  autopilot: 'AUTOPILOTTI PÄÄLLÄ',
  manualMode: 'MANUAALINEN',
  enableAutopilot: 'Kytke autopilotti',
  disableAutopilot: 'Pysäytä autopilotti',
  hammerDelay: 'Vasarointiviive',
  hammerDelayHelp:
    'Kuinka kauan autopilotti odottaa tarjousajan päätyttyä ennen kuin vasaroi kohteen. Myöhässä tulleet huudot ehtivät vielä mukaan ja käynnistävät tarjousajan uudelleen.',
  orders: 'Tilaukset',
  items: 'Kohteet',
  phoneNumber: 'Puhelinnumero',
  bidCount: 'Huutolaskuri',
  myWork: 'MyWork',
  clients: 'Asiakkaat',
  editClientN: 'Muokkaa asiakasta {{ holmastoId }} ',
  userDocuments: 'Asiakkaan asiakirjat',
  note: 'Huomautus',
  notes: 'Huomautukset',
  inWarehouse: 'Varastossa',
  auctionStatus: 'Huutokaupan status',
  maxBiddingLevel: 'Hyväksytty huutotaso',
  copyProduct: 'Kopioi tuote',
  productWasSaved: 'Tuote on tallennettu',
  productWasCreated: 'Tuote on luotu',
  publishOnline: 'Valmis ja Julkaise ',
  markAsFeatured: 'Merkkaa näkyviin pääsivulla',
  itemsCountN: 'Kohdelaskuri: {{ n }}',
  bidsCountN: 'Huutolaskuri: {{ n }}',
  auctionN: 'Huutokauppa {{ n }}',
  itemsSoldN: 'Myydyt kohteet: {{ n }}',
  trendingItems: 'Suositut kohteet',
  trendingCategories: 'Suositut kategoriat',
  price: 'Hinta',
  unpublish: 'Lopeta julkaisu',
  compensate: 'Tilitä',
  undoCompensation: 'Peruuta tilitys',
  compensated: 'Tilitetty',
  yes: 'Kyllä',
  no: 'Ei',
  sum: 'Summa',
  commission: 'Provisio',
  sellerReceives: 'Myyjälle tilitetään',
  sellerCommissions: 'Myyjäprovisio',
  sellerProducts: 'Myyjän tuotteet',
  startAmount: 'Alkusumma',
  soldAmount: 'Loppusumma',
  sellerCommissionWasUpdated: 'Myyjäprovisio on päivitetty',
  update: 'Päivitä',
  auctionHasUnpublishedProducts: 'Huutokauppaan on liitetty keskeneräisiä tuotteita, haluatko silti jatkaa?',
  editSeller: 'Muokkaa myyjä',
  sellers: 'Myyjät',
  accountNumber: 'Tilinumero (IBAN)',
  accountNumberRequired: 'Tilinumero vaaditaan tilisiirtoa varten',
  bankAccountWillBeReadFromCustomerDetails: 'Tilinumero luetaan asiakastiedoista',
  countries: 'Maat',
  none: 'Ei mitään',
  receptionWasSaved: 'Vastaanotto on tallennettu',
  attachedCard: 'Liitteenä kortti',
  lastDigits: 'Viimeiset numerot',
  expirationDate: 'Viimeinen voimassaolopäivä',
  accountType: 'Tilin tyyppi',
  personal: 'Henkilö',
  business: 'Yritys',
  businessId: 'Y-tunnus',
  contactPerson: 'Yhteyshenkilö',
  handlingOrganizationName: 'Asiaa hoitavan organisaation nimi',
  shippingOrderStatus: 'Toimituksen tila',
  manageOrder: 'Käsittele tilauksia',
  manageShippingOrder: 'Käsittele toimituksia',
  verified: 'On hyväksytty',
  serialNumber: 'Sarjanumero',
  zipCode: 'Postinumero',
  liveAuctionStarted: 'Live-huutokauppa on alkanut',
  liveAuctionEnded: 'Huutokauppa on sulkeutunut',
  shippingIsSameAsBilling: 'Toimitusosoite sama kuin laskutusosoite',
  shippingAddress: 'Toimitusosoite',
  billingAddress: 'Laskutusosoite',
  nationality: 'Kansallisuus',
  bidLimitRequests: 'Pyyntö huutorajan nostolle',
  disabled: 'Ei käytettävissä',
  editBid: 'Muokkaa huutoa',
  notifyWhenBidIsWinning: 'Ilmoita kun minulla on voittava huuto',
  notifyWhenBidIsntWinning: 'Ilmoita kun huutoni on ylitetty',
  notifications: 'Ilmoitukset',
  wrongCredentials: 'Sähköpostiosoite tai salasana on väärä',
  generateExcel: 'Generoi Excel-tiedosto',
  alreadyCompensated: 'Tilitys tehty',
  sellerGets: 'Myyjän osuus',
  invoice: 'Lasku',
  approvedReceptions: 'Hyväksytyt sisäänostotarjoukset',
  passwordConfirmation: 'Vahvista salasana',
  passwordShouldBeMinimum: 'Salasanan vähimmäisvaatimus {{ minimum }}',
  passwordsMustMatch: 'Salasana ei täsmä',
  unknownError: 'Tuntematon virhe tapahtui',
  serverErrorTryAgain: 'Palvelinvirhe, yritä uudelleen',
  confirmDeleteReception: 'Oletko varma, että haluat poistaa vastaanoton? Tätä toimintoa ei voi peruuttaa.',
  isWinning: 'Voittava tarjous',
  userName: 'Asiakkaan nimi',
  lotNumber: 'Kohdenumero',
  marginalRate: 'Marginaaliverotus',
  vatPercent: 'ALV %',
  openOrders: 'Avoimet tilaukset',
  createWebshopOrder: 'Luo verkkokauppatilaus',
  sellerCommission: 'Myyjäprovisio',
  buyerCommission: 'Ostajaprovisio',
  generateSoldProductExcel: 'Generoi vasarahinta-Excel',
  system: 'Ennakkotarjous',
  online: 'Online',
  facilitator: 'Sali',
  wonItems: 'Voitetut kohteet',
  wonPrice: 'Vasarahinta',
  receptions: 'Vastaanotot',
  soldProducts: 'Myydyt kohteet',
  paidWith: 'Maksettu:',
  shipment: 'Toimitus',
  total: 'Yhteensä',
  view: 'Katso',
  open: 'Aktiivinen',
  closed: 'Suljettu',
  deadline: 'Määräaika',
  openReceptionIAmPersonalAssigned: 'Avoin vastaanotto jossa olen vastuuhenkilö',
  pendingReceptionsAssignedToMe: 'Odottavat vastaanotot',
  readyToSendReceptionsAssignedToMe: 'Vastaanotot valmiina lähetettäväksi',
  sendReminder: 'Muistuta arvioinnista',
  remind: 'Muistutus',
  reminderWasSent: 'Muistutus lähetetty',
  openReceptionIAmExpert: 'Avoin vastaanotto jossa minulla on tehtävä',
  id: 'ID ',
  daysBeforeDeadline: 'päivää jäljellä määräaikaan',
  openItemAcceptancesWhereIAmAssignedReception: 'Avoimet vastaanoton kohdehyväksynnät johon minut on kiinnitetty',
  openItemAcceptancesWhereIAmAssigned: 'Avoimet kohdehyväksynnät johon minut on kiinnitetty',
  receptionId: 'Vastaanoton numero',
  receptionPersonell: 'Vastaanoton henkilöstö',
  customerName: 'Asiakkaan nimi',
  sellerName: 'Myyjän nimi',
  bidsTotal: 'Huutoja yhteensä',
  uniqueCustomersWithBids: 'Uniikit huutajat',
  itemsWithBids: 'Kohteita jossa huutoja',
  sumOfWinningPreBids: 'Ennakkohuudettujen kohteiden yhteissumma',
  sumOfWinningLiveBids: 'Vasarahintojen yhteissumma',
  soldItems: 'Myydyt kohteet',
  categoriesWithMostBids: 'Kategoriat joissa eniten huutoja',
  kpi: 'Huutokauppatilastot',
  auctionTotals: 'Huutokaupan tuotto',
  openReceptions: 'Avoimet vastaanotot',
  openItems: 'Avoimet asiakkaiden kohteet',
  newCustomers: 'Uudet asiakkaat',
  requestedAt: 'Pyyntö lähetetty',
  payments: 'Maksaminen',
  totalSum: 'Yhteissumma',
  completedOrders: 'Valmiit tilaukset',
  shippingMethod: 'Toimitusmuoto',
  buyerPays: 'Ostaja maksaa',
  orderItems: 'Tilauksen kohteet',
  acceptedReceptionProposals: 'Hyväksytyt ostotarjoukset',
  notCompensated: 'Tilittämättä',
  numberOfItems: 'Kohteiden lukumäärä',
  paymentStatus: 'Maksun status',
  compensationStatus: 'Tilityksen status',
  fee: 'Käsittelumaksu',
  sellerItems: 'Myyjän kohteet',
  sellerSoldItems: 'Myydyt myyjän kohteet',
  compensatedWithoutPurchaseInvoice: 'Tilitetty ilman ostolaskua',
  compensateSeller: 'Suorita tilitys myyjälle',
  createPurchaseInvoices: 'Luo ostolasku valinnalle',
  markPaidInStore: 'Merkitse maksetuksi liikkeessä',
  language: 'Kieli',
  generateContract: 'Generoi sopimus',
  verificationMethod: 'Tunnistustapa',
  basic_info_filled: 'Perustiedot syötetty',
  copyProductToNewAuction: 'Kopioi tuote toiseen huutokauppaan',
  copyToAuction: 'Kopioi huutokauppaan',
  totalCommission: 'provisio yhteensä',
  boughtBy: 'Ostaja',
  buyerUnknown: 'Ostaja ei tiedossa',
  unsavedChangesPrompt: 'There are some unsaved changes (fi)',
  clientWasUpdated: 'Client was updated (fi)',
  clientWasCreated: 'Client was created (fi)',
  categoryWasUpdated: 'Category was updated (fi)',
  categoryWasCreated: 'Category was created (fi)',
  tagWasUpdated: 'Tag was updated (fi)',
  tagWasCreated: 'Tag was created (fi)',
  receptionWasUpdated: 'Reception was updated (fi)',
  receptionWasCreated: 'Reception was created (fi)',
  timerIsStillActive: 'Timer is still active (fi)',
  onlineCustomers: 'Online Customers (fi)',
  otherCustomers: 'Other Customers (fi)',
  evaluation: 'Arviointi',
  toSell: 'Myyntitarkoitus',
  estateInventory: 'Perunkirjoitus',
  insuranceEvaluation: 'Vakuutusarviointi',
  gemmologicalExamination: 'Gemmologinen tutkimus',
  purposeOfSale: 'Toimeksiannon tarkoitus',
  toAuction: 'Huutokauppaan',
  salesOrder: 'Myyntitili',
  notifySeller: 'Notify seller (fi)',
  oneTimeCustomers: 'Kertaluontoiset asiakkaat',
  paidInStore: 'Paid in store (fi)',
  before: 'Ennen',
  after: 'Jälkeen',
  verifyUsers: 'Verify users (fi)',
  internalError: 'Internal Error (fi)',
  proposal: 'Ehdotus',
  proposalPdf: 'Proposal PDF (fi)',
  printTheReceptionReceipt: 'Tulosta vastaanoton kuitti',
  enableEdit: 'Ota käyttöön',
  disableEdit: 'Ota pois käytöstä',
  approved: 'Approved (fi)',
  created: 'Aloitettu',
  readyToSend: 'Valmis lähetettäväksi',
  published: 'Julkaistu',
  declined: 'Ei hyväksytty',
  auctionCountdown: 'Auction should start in {{ m }} Months, {{ d }} days, {{ h }} hours, {{ s }} seconds (fi)',
  notifyUsersToPay: 'Notify users to pay (fi)',
  sentWaitingForAnswer: 'Lähetetty, odottaa vastausta',
  liveAuctionWillStartIn: 'Live-huutokaupan alkuun',
  other: 'Muu',
  pendingEmails: 'Kirjautumissähköpostin vahvistukset',
  resendEmail: 'Lähetä sähköposti uudelleen',
  yourRequestHasCompleted: 'Lähetä viesti: Jättämänne toimeksianto on suoritettu',
  userWasAlreadyNotifiedNotifyAgain: 'Email was already send. Do you want to send again? (fi)',
  companyName: 'Yrityksen nimi',
  company: 'Yrityksen nimi',
  proposalSent: 'Ehdotus lähetetty',
  tools: 'Työkalut',
  management: 'Hallinta',
  notifiSellerReceptionReceived: 'Lähetä viesti: Olemme vastaanottaneet esineesi arvioitavaksi',
  printTheQrCode: 'Tulosta QR koodi',
  qrCodeError: 'QR-koodia ei voida luoda: tuotteen tunniste puuttuu',
  directPurchase: 'Suoraosto',
  notifyReceptionEvaluationHasCompleted: 'Lähetä viesti: Arviointityö on valmistunut!',
  printSalesReceipt: 'Tulosta myyntitosite',
  createPurchaseInvoice: 'Luo ostolasku',
  purchaseInvoiceWasCreated: 'Ostolasku luotiin',
  sendSalesContract: 'Lähetä viesti: Myyntisopimus',
  printSalesContract: 'Tulosta myyntisopimus',
  notificationWasSent: 'Ilmoitus lähetettiin',
  startLiveAuction: 'Käynnistä live-huutokauppa',
  auctionHasNoProducts: 'Ole hyvä ja lisää tuotteita huutokauppaan ennen kuin käynnistät livehuutokaupan',
  saveChanges: 'Tallenna muutokset',
  updateFastTrackReception: 'Muokkaa pikaostoa',
  unPublished: 'Julkaisematon',
  markAsCompensated: 'Merkitse maksetuksi liikeessä',
  address: 'Osoite',
  streetAddress: 'Katuosoite',
  phone: 'Puhelinnumero',
  phoneNumberAlreadyExists: 'Puhelinnumero on jo käytössä',
  emailAlreadyExists: 'Sähköposti on jo käytössä',
  fastTrackReceptionWasUpdated: 'Pikaosto päivitetty',
  fastTrackReceptionWasCreated: 'Fast track reception was created (fi)',
  add: 'Lisää',
  history: 'Historia',
  cash: 'Käteinen',
  bankTransfer: 'Tilisiirto',
  netvisor: 'Netvisor',
  paymentMethod: 'Maksutapa',
  taxClass: 'Veroluokka',
  fastBuyItems: 'Kauppatavaran tiedot',
  productCantBePublished: "Productb {{ sku }} can't be published",
  setStatus: 'Päivitä valittujen tuotteiden tila',
  accountNumberIsRequired: 'In order to create purchase invoice fill account number',
  fastTrackReceptions: 'Pikaosto',
  addRow: 'Lisää rivi',
  addItem: 'Lisää kohde',
  receipts: 'Tositteet',
  addFastTrackReception: 'Lisää uusi pikaosto',
  socialSecurityNumber: 'Syntymäaika ja sosiaaliturvatunnus',
  form: 'Lomake',
  createSalesContract: 'Luo myyntisopimus',
  runningNumber: 'Running number',
  productWasUnsold: 'Product was unsold (fi)',
  sellToUser: 'Sell to user (fi)',
  youReAboutToChangeAssignedAuctionId: "You're about to change assigned auction (fi)",
  youCantChangeSoldProductsAuction: "You can't change assigned auction for sold product (fi)",
  addBillingAddress: 'Lisää laskutusosoite',
  itemWasSoldToTheUser: 'Items as sold to user (fi)',
  printActions: 'Print actions',
  editProduct: 'Edit product',
  unlockForEditing: 'Unlock for editing',
  lockForEditing: 'Lock for editing',
  afterAuctionTools: 'After auction tools',
  unsell: 'Unsell',
  purchaseItemToHolmasto: 'Purchase item to holmasto',
  moveToAnotherAuction: 'Move to another auction',
  previewProductInCatalogue: 'Preview auction in catalogue',
  returnedToSeller: 'Returned to seller (fi)',
  sold: 'Myyty',
  current: 'Current (fi)',
  waiting: 'Waiting (fi)',
  biddingEnded: 'Bidding ended (fi)',
  readyForCatalogue: 'Valmis luetteloon',
  actions: 'Actions (fi)',
  soldToHolmasto: 'Sold to holmasto (fi)',
  movedFromEarlierAuction: 'Moved from earlier auction (fi)',
  itemCreated: 'Luotu',
  updated: 'Päivitetty',
  grouped: 'Kohteet',
  list: 'Viimeisimmät huudot',
  type: 'Tyyppi',
  verfictionStatus: 'Hyväksymistaso',
  disableFromCatalogue: 'Disable from catalogue (fi)',
  enableInCatalogue: 'Enable in catalogue (fi)',
  featuredImages: 'Featured Images (fi)',
  startPrice: 'Start price',
  filterItemDescription: 'Filter item description',
  copy: 'Copy',
  historyItems: 'History items (fi)',
  itemWasCompied: 'Item was copied',
  createWebshopProduct: 'Create webshop product',
  webshopProduct: 'Webshop product',
  editWebshopProduct: 'Edit webshop product ({{ lang }})',
  showFullTable: 'Show full table (fi)',
  tempId: 'Väliaikainen tunnus',
  archived: 'Arkistoitu',
  archive: 'Arkistoi',
  archiveLabel: 'Arkisto',
  archiveReception: 'Arkistoi',
  unarchive: 'Palauta avoimeksi',
  proposalWasSent: 'Sales contract was sent',
  holmastoItems: 'Holmaston kohteet',
  customerItems: 'Asiakkaiden kohteet',
  allItems: 'Kaikki kohteet',
  customerDistribution: 'Asiakasjakauma',
  notSoldItems: 'Myymättömät kohteet',
  avgPrice: 'keskihinta',
  startingAvgPrice: 'lähtohintojen keskihinta',
  holmastoSalesTotal: 'Holmaston tuotteiden kokonaismyynti',
  buyerCommissionTotal: 'Ostajien provisiot yhteensä',
  sellerPayoutTotal: 'Myyjien tilitykset yhteensä',
  collapseAll: 'Sulje kaikki',
  expandAll: 'Avaa kaikki',
  checkingSyncStatus: 'Tarkistetaan synkronointitilaa...',
  errorCheckingSyncStatus: 'Virhe synkronointitilan tarkistuksessa',
  productsInSync: 'Tuotteet ovat ajan tasalla',
  productsOutOfSync: 'Tuotteet eivät ole ajan tasalla',
  missingProducts: '{{count}} tuote(tta) puuttuu huutokaupasta',
  extraProducts: '{{count}} ylimääräistä tuotetta huutokaupassa',
  outdatedProducts: '{{count}} tuote(tta) vaatii päivityksen',
  syncNow: 'Synkronoi tuotteet',
  syncing: 'Synkronoidaan...',
  syncCompleted: 'Synkronointi valmis: {{added}} lisätty, {{updated}} päivitetty, {{removed}} poistettu',
  syncFailed: 'Synkronointi epäonnistui',
  lotNumbersLockedSyncNote:
    'Huom: Kohdenumerot on lukittu (katalogi julkaistu tai ennakkohuuto alkanut) - vain olemassa olevat tuotteet päivitetään. Tuotteita ei lisätä tai poisteta (kohdenumerot säilytetään). Kategoriahierarkiat lasketaan uudelleen.',
  generatePreviewCatalogue: 'Luo esikatselukatalogi (yksityinen)',
  generatePublicCatalogue: 'Luo julkinen katalogi',
  generatePublicCatalogueWithHammerPrice: 'Luo julkinen katalogi kaatohinnalla',
  productsOutOfSyncConfirmPublish:
    'Tuotteet eivät ole synkronoitu! Julkaiseminen nyt voi näyttää virheellistä tietoa asiakkaille. Haluatko julkaista joka tapauksessa?\n\nSuositus: Paina Peruuta, klikkaa sitten "Synkronoi nyt" -painiketta tuotteiden yläpuolella ja julkaise sen jälkeen.',
  viewOutOfSyncDetails: 'Näytä synkronoinnista poikkeavat tuotteet',
  reason: 'Syy',
  'syncReason.missing': 'Puuttuu huutokaupasta',
  'syncReason.extra': 'Ylimääräinen huutokaupassa',
  'syncReason.outdated': 'Vanhentunut',
  'syncReason.fields': 'Kentät vanhentuneet',
  'syncReason.categories': 'Kategoriat vanhentuneet',
  'syncReason.fields, categories': 'Kentät ja kategoriat vanhentuneet',
  nonPublishedAssignedProducts: '{{count}} määritettyä tuotetta ei vielä julkaistu',
  nonPublishedAssignedProductsNote:
    'Nämä tuotteet on määritetty tähän huutokauppaan, mutta niitä ei ole vielä julkaistu. Ne näkyvät huutokaupan alikokoelmassa, kun niiden tila muutetaan "julkaistuksi" (Valmis luetteloon).',
  viewNonPublishedProducts: 'Näytä julkaisemattomat tuotteet',
  searchClients: 'Etsi asiakkaita',
  noClientsFound: 'Asiakkaita ei löytynyt',
  clientDetails: 'Asiakkaan tiedot',
  accountType_personal: 'Yksityisasiakas',
  accountType_business: 'Yritysasiakas',
  accountTypeMissing: 'Tilin tyyppi puuttuu',
  valueMissing: '{{ valueName }} puuttuu',
  createNewReception: 'Luo uusi vastaanotto',
  itemLocation: 'Tavaran sijainti',
  customerPicksUpNonValuable: 'Asiakas noutaa arvottomat',
  listingPrice: 'Myyntihinta',
  customerSharePercent: 'Asiakkaan osuus %',
  customerShareAmount: 'Asiakkaan osuus €',
  pleaseFixErrorsAndTryAgain: 'Korjaa virheet ja yritä uudelleen',
  salesExpenses: 'Myyntikulut',
  expertServices: 'Asiantuntijapalvelut',
  gemmologist: 'Gemmologi',
  goldsmith: 'Kultaseppä',
  certificate: 'Arviointitodistus',
  otherExpert: 'Muu asiantuntija',
  done: 'Loppuun käsitelty',
  notDone: 'Käsittelemättä',
  eventHistory: 'Tapahtumahistoria',
  noChangelogFound: 'Muutoslokia ei löytynyt',
  noReceptionsFound: 'Vastaanottoja ei löytynyt',
  noNotesFound: 'Huomautuksia ei löytynyt',
  expertServiceDetails: 'Asiantuntijapalvelun tiedot',
  serviceType: 'Palvelun tyyppi',
  intake: 'Vastaanotto',
  selectReceptionCategory: 'Valitse toimeksiannon tyyppi',
  personalIdOrBirthdate: 'Henkilötunnus tai syntymäaika',
  intakeCategoryDescription: 'Myyntitarkoitus, huutokauppaan menevät kohteet, tai myyntili',
  expertCategoryDescription: 'Gemmologinen tutkimus, kultasepän työt, arviointitodistus tai muu asiantuntijapalvelu',
  fastTrackCategoryDescription: '',
  selectExpertServiceTypeToBegin: 'Valitse asiantuntijapalvelun tyyppi',
  createNewCase: 'Uusi toimeksianto',
  currentData: 'Nykyiset tiedot',
  profileMissingRequiredFields: 'Asiakkaan profiilista puuttuu pakollisia tietoja:',
  addNewNote: 'Lisää huomautus',
  close: 'Sulje',
  erasurePreviewIntro:
    'Nämä asiakastiedot voivat kuulua samalle henkilölle. Poistettava asiakas ja samat henkilöt on valittu valmiiksi; tarkista muut ja valitse poistettavat.',
  erasureConfidence_requested: 'Poistettava asiakas',
  erasureConfidence_likely: 'Todennäköisesti sama henkilö',
  erasureConfidence_possible: 'Mahdollisesti sama henkilö',
  erasureMatchedBy: 'Löytyi',
  erasureMatch_personalId: 'Henkilötunnus',
  erasureMatch_email: 'Sähköposti',
  erasureMatch_authEmail: 'Kirjautumissähköposti',
  erasureMatch_phone: 'Puhelin',
  erasureViaCandidate: 'toisen asiakkaan tietojen kautta',
  erasureDiffers: 'Eroaa',
  erasureActivity_bids: 'Tarjoukset',
  erasureActivity_orders: 'Tilaukset',
  erasureActivity_receptions: 'Vastaanotot',
  erasureActivity_fastTrackReceptions: 'Pikaostot',
  erasureActivity_sellerCommissions: 'Myyjäprovisiot',
  erasureKind_fastTrackReception: 'Vanha pikaosto ilman profiilia',
  holmastoId: 'Holmasto ID',
  erasureColumn_record: 'Asiakas',
  erasureColumn_contact: 'Yhteystiedot',
  erasureColumn_comparison: 'Vertailu pyydettyyn',
  erasureColumn_status: 'Toiminta ja tila',
  erasureRequestedProfile: 'Muita verrataan tähän asiakkaaseen',
  erasureBlocked: 'Poistoa ei voi tehdä ennen kuin nämä on hoidettu',
  erasureBlocker_bidInOpenAuction: 'Tarjous huutokaupassa, joka ei ole päättynyt',
  erasureBlocker_uncompensatedFastTrackReception: 'Tilittämätön pikaosto',
  erasureBlocker_uncompensatedSellerCommission: 'Tilittämätön myyjäprovisio',
  erasureBlocker_staffAccount: 'Henkilökunnan tunnus, ei poisteta tästä',
  erasureRetention: 'Säilytetään {{date}} asti',
  erasureRetention_seller: 'Myyjä',
  erasureRetention_buyer: 'Ostaja',
  erasureRetainedInfo:
    '{{count}} valitun asiakkaan tunnistustiedot säilytetään kuuden vuoden ajan viimeisen oston tai myynnin vuoden päättymisestä. Muut tiedot poistetaan.',
  erasureSelected: 'Valittuja: {{count}}',
  erasureWarning_openReception: 'Keskeneräinen vastaanotto',
  erasureWarning_unpaidOrder: 'Maksamaton tilaus',
  erasureCheckBefore: 'Tarkista ennen poistoa',
  erasureConfidence_certain: 'Sama henkilö',
  erasureMatch_accountNumber: 'Tilinumero',
  erasureMatch_surnameAndBirthDate: 'Sukunimi ja syntymäaika',
  erasureMatch_nameAndPostalCode: 'Nimi ja postinumero',
  erasureConflicts: 'Ristiriita',
  erasureConflict_personalId: 'Eri henkilötunnus',
  erasureConflict_name: 'Eri nimi',
  erasureBirthDate: 'Syntymäaika',
  erasurePersonalId: 'Henkilötunnus',
  erasureAccountNumber: 'Tilinumero',
  erasureComparison_same: 'sama',
  erasureComparison_different: 'eri',
  erasureWarning_thirdPartyName: 'Nimikentässä voi olla toisen henkilön tietoja',
  back: 'Takaisin',
  erasureOpen: 'Poista asiakkaan tiedot',
  erasureTitle: 'Asiakkaan tietojen poisto',
  erasureNoOthersFound:
    'Muita samalle henkilölle mahdollisesti kuuluvia asiakastietoja ei löytynyt. Hakuun käytettiin henkilötunnusta, sähköpostia, puhelinnumeroa, tilinumeroa ja nimeä.',
  erasureStep_select: 'Asiakastiedot',
  erasureStep_verify: 'Pyyntö ja tunnistus',
  erasureStep_summary: 'Tarkistus ja poisto',
  erasureStep_done: 'Asiakkaan tiedot poistettu',
  erasureContinue: 'Jatka',
  erasureShowSummary: 'Näytä mitä poistetaan',
  erasureErase: 'Poista pysyvästi',
  erasureConfirm: 'Poistetaanko {{count}} asiakkaan tiedot pysyvästi? Poistoa ei voi perua.',
  erasureDone: 'Tiedot on poistettu ja poisto kirjattu. Tee alla olevat käsin tehtävät askeleet.',
  erasureSummaryIntro: 'Mitään ei ole vielä poistettu.',
  erasureErrorBlocked: 'Poisto on estetty: jonkin valitun asiakkaan tiedot ovat muuttuneet. Avaa poisto uudelleen.',
  erasureErrorWarnings: 'Kuittaa varoitukset ennen poistoa.',
  erasureErrorInvalid:
    'Tarkista tiedot: valinta tai lomake ei kelpaa. Avaa poisto uudelleen, jos asiakastiedot ovat muuttuneet.',
  erasureRequestReceivedAt: 'Pyyntö saapui',
  erasureRequestReceivedAtHelp: 'Vastaus on annettava kuukauden kuluessa tästä päivästä.',
  erasureNoPersonalData:
    'Kenttiin ei kirjata henkilötunnusta eikä asiakirjojen numeroita, koska tiedot tallentuvat poistolokiin.',
  erasureVerificationMethod: 'Miten henkilöllisyys varmistettiin?',
  erasureMethod_emailRequest: 'Pyyntö tuli rekisterissä olevasta sähköpostiosoitteesta',
  erasureMethod_sms: 'SMS-koodi rekisterissä olevaan puhelinnumeroon',
  erasureMethod_email: 'Vahvistus rekisterissä olevasta sähköpostista',
  erasureMethod_emailHelp: 'Erillinen viesti rekisterin osoitteeseen, johon asiakas vastasi',
  erasureMethod_inPerson: 'Henkilöllisyystodistus tarkistettu paikan päällä',
  erasureMethod_other: 'Muu tapa',
  erasureMethod_otherDescription: 'Kuvaa tapa',
  erasureReferenceHelp: 'Esim. sähköpostin aihe tai tiketin numero.',
  erasureVerifiedAt: 'Varmistettu',
  erasureReference: 'Mistä pyyntö löytyy',
  erasureWarningsAcknowledged: 'Olen tarkistanut nämä ennen poistoa:',
  erasureAcknowledge_openReception: 'keskeneräiset vastaanotot on käsitelty ja esineet palautettu',
  erasureAcknowledge_unpaidOrder: 'maksamattomia tilauksia ei enää peritä',
  erasureAcknowledge_thirdPartyName: 'nimikentän muiden henkilöiden tiedot on selvitetty',
  erasureWillDelete: 'Poistetaan',
  erasureDeleted: 'Poistettu',
  erasureWillClear: 'Henkilötiedot tyhjennetään',
  erasureCleared: 'Henkilötiedot tyhjennetty',
  erasureKeptUntil: 'Tunnistustiedot säilytetään {{date}} asti.',
  erasureKeptDocuments: 'Tunnistusasiakirjoja säilytetään: {{count}}.',
  erasureNothingKept: 'Mitään ei säilytetä.',
  erasureKeptWithoutDetails: 'Säilyy ilman henkilötietoja',
  erasureKept_bids: 'tarjoukset',
  erasureKept_orders: 'tilaukset',
  erasureCopy: 'Kopioi',
  erasureCopied: 'Kopioitu',
  erasureManualSteps: 'Poiston jälkeen tee käsin',
  erasureManual_woocommerce:
    'WooCommerce: avaa WordPressin henkilötietojen poisto ja tee jokaiselle alla olevalle sähköpostille',
  erasureManual_woocommerceStep_paste: 'Kopioi sähköposti ja liitä se kenttään "Käyttäjätunnus tai sähköpostiosoite"',
  erasureManual_woocommerceStep_noConfirmation:
    'Poista ruksi kohdasta "Lähetä henkilötietojen poiston vahvistusviesti": henkilöllisyys on jo varmistettu. Ruksin kanssa WordPress odottaa asiakkaan vahvistusta eikä poista mitään.',
  erasureManual_woocommerceStep_erase:
    'Paina nappia "Lähetä vahvistusviesti" (viestiä ei lähetetä, kun ruksi on poistettu) ja sen jälkeen pyynnön rivillä "Poista henkilötiedot"',
  erasureManual_noEmail: 'Valituilla asiakkailla ei ole sähköpostia',
  erasureManual_reply: 'Vastaa asiakkaalle: mitä poistettiin ja mitä säilytetään',
  erasureManual_thirdParty:
    'Nimikentässä on toisen henkilön tietoja: selvitä erikseen, pyyntö koskee vain pyytäjän omia tietoja',
  erasureCount_authUser: 'MyHolmasto-tunnus',
  erasureCount_profile: 'asiakasprofiili',
  erasureCount_profileSubcollections: 'muistiinpanot, maksukorttivarmennuksen tiedot ja toivelista',
  erasureCount_storageFiles: 'ladatut tiedostot',
  erasureCount_changelogsDeleted: 'asiakkaan muutosloki',
  erasureCount_rateLimits: 'kirjautumisyritysten laskurit',
  erasureCount_products: 'tuotteet',
  erasureCount_receptions: 'vastaanotot',
  erasureCount_receptionExperts: 'vastaanottojen asiantuntijakopiot',
  erasureCount_paletteUsers: 'palettinumerot',
  erasureCount_sellerCommissions: 'myyjäprovisiot',
  erasureCount_fastTrackReceptions: 'pikaostot',
  erasureCount_changelogsScrubbed: 'tuotteiden, vastaanottojen ja pikaostojen muutoslokit',
})

export default fi
